import { render } from "./RecognisedQualifications.vue?vue&type=template&id=13489b66&scoped=true"
import script from "./RecognisedQualifications.vue?vue&type=script&lang=js"
export * from "./RecognisedQualifications.vue?vue&type=script&lang=js"

import "./RecognisedQualifications.vue?vue&type=style&index=0&id=13489b66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13489b66"]])

export default __exports__